export const tableConstants = {
  perPage: 25,
};
